

















import { Vue, Component } from "@/shared/vuepack";
import { ReportsAdminBillingDetail,
        ReportsAdminBillingEmployeeFees,
        ReportsAdminBillingSummary,
        ReportsAdminFraudPrevention,
        ReportsAdminDemoUsers } from "@/admin/route-names";
import { Config } from "@/shared/config";

@Component
export default class AdminReports extends Vue {
  ReportsAdminBillingDetail = ReportsAdminBillingDetail;
  ReportsAdminBillingEmployeeFees = ReportsAdminBillingEmployeeFees;
  ReportsAdminBillingSummary = ReportsAdminBillingSummary;
  ReportsAdminFraudPrevention = ReportsAdminFraudPrevention;
  ReportsAdminDemoUsers = ReportsAdminDemoUsers;

  get showDemoUsersReportLink () {
    const isUat = Config.UserServicebaseUri.indexOf("https://api-uat.live-test-domain.com") >= 0;
    const isProduction = Config.UserServicebaseUri.indexOf("https://api.bendhsa.com") >= 0;
    return !isUat && !isProduction;
  }
}
